import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import "@/i18n";
import App from "@/App";
import { ErrorBoundary } from "@/components/ErrorBoundary";

// Suppress DOM manipulation errors caused by browser translate/extensions
// These errors occur when Chrome Translate wraps text nodes in <font> tags
// and React can't find the original node to remove
const originalConsoleError = console.error;
console.error = (...args) => {
  const msg = typeof args[0] === 'string' ? args[0] : '';
  if (msg.includes('removeChild') || msg.includes('insertBefore')) return;
  originalConsoleError.apply(console, args);
};

window.addEventListener('error', (event) => {
  if (
    event.error?.name === 'NotFoundError' &&
    (event.error?.message?.includes('removeChild') ||
     event.error?.message?.includes('insertBefore'))
  ) {
    event.stopImmediatePropagation();
    event.preventDefault();
    return true;
  }
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <ErrorBoundary>
    <App />
  </ErrorBoundary>,
);

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js')
      .then((registration) => {
        // Auto-update service worker
        registration.addEventListener('updatefound', () => {
          const newWorker = registration.installing;
          if (newWorker) {
            newWorker.addEventListener('statechange', () => {
              if (newWorker.state === 'activated') {
                window.location.reload();
              }
            });
          }
        });
      })
      .catch(() => {});
  });
}
